import { jsx as _jsx } from "react/jsx-runtime";
export function Suggestions({ suggestions, onPick, disabled }) {
    if (!suggestions.length)
        return null;
    return (_jsx("div", { className: "ac-chips", role: "group", "aria-label": "Suggested questions", children: suggestions.map((s) => (_jsx("button", { type: "button", className: "ac-chip", disabled: disabled, onClick: () => onPick(s.value ?? s.label), children: s.label }, s.id))) }));
}
